import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const selfMadeBillionaireQuestsList: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow Self-made Billionaire",
    caption: "Get exclusive content and updates",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f8e26689-9487-463d-af6c-48d7bae6f5fe-wishlist-added",
    ruleId: "f8e26689-9487-463d-af6c-48d7bae6f5fe-wishlist",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Download and Play Now",
    caption: "Play now and earn rewards",
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f8e26689-9487-463d-af6c-48d7bae6f5fe-website-event",
    ruleId: "f8e26689-9487-463d-af6c-48d7bae6f5fe-website",
    linkUrl: "https://ntiny.link/selfmade-billionaire4",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord Community",
    caption: "Connect with players and join the discussion",
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f8e26689-9487-463d-af6c-48d7bae6f5fe-discord-event",
    ruleId: "f8e26689-9487-463d-af6c-48d7bae6f5fe-discord",
    linkUrl: "https://discord.gg/marblexgames",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow on X",
    caption: "Stay updated with the latest news and events",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f8e26689-9487-463d-af6c-48d7bae6f5fe-twitter-event",
    ruleId: "f8e26689-9487-463d-af6c-48d7bae6f5fe-twitter",
    linkUrl: "https://x.com/MARBLEXofficial",
  },
];

export const selfMadeBillionaireQuests: QuestGroup[] = [
  {
    key: "level-0",
    header: {
      image: "",
      description: "",
      title: "Learn and connect",
    },
    nextQuest: {
      url: "/",
      title: "Thanks for getting involved",
      label: "Discover new games you can support",
      caption: "Do quests & earn rewards",
    },
    totalGemsGranted: 50,
    quests: selfMadeBillionaireQuestsList,
  },
];
